<template>
  <div class="bg-bluegray-700 min-h-screen lg:ml-56 lg:mr-44">
    <!-- HEADING -->
    <div class="lg:h-72 flex justify-start items-end p-12 bg-bluegray-100">
      <div
        class="border-l-4 pl-6 border-black flex flex-col justify-end items-end m-0 p-0 w-full"
      >
        <h1 class="w-full text-left">Profile Settings</h1>
        <span class="text-md w-full text-left"
          >Manage your Exhibitor Profile</span
        >
      </div>
    </div>

    <!-- CONTENT -->
    <div
      class="flex flex-col lg:flex-row lg:space-x-6 mx-6 lg:mx-12 py-6 lg:py-12"
    >
      <!-- CONTENT Col 1 -->
      <div
        class="bg-white rounded-xl shadow w-full lg:w-1/2 p-6 mb-12 lg:mb-0 2xl:py-12 2xl:px-12"
      >
        <div class="pb-8 flex flex-col max-w-4xl relative">
          <button
            :disabled="!canSubmit || thinking"
            :class="[!canSubmit ? 'opacity-25 cursor-not-allowed' : '']"
            type="submit"
            class="absolute right-4 top-4"
            @click="submitUpdates"
          >
            <div
              :class="[
                !canSubmit ? 'border border-bluegray-700' : 'btn-primary',
                thinking ? 'thinking-primary cursor-not-allowed' : '',
              ]"
              class="relative btn"
            >
              <div
                class="absolute inset-0 w-full flex justify-center items-center z-20"
              >
                <lottie v-if="thinking" :options="loadingAnimationOptions" />
              </div>
              <span :class="[thinking ? 'invisible' : '']">Save Changes</span>
            </div>
          </button>

          <div class="w-full py-8 border-b border-bluegray-300">
            <h2>Exhibitor Info</h2>

            <!-- Exhibitor Name -->
            <div class="pt-8 pb-4">
              <label
                for="profile_title"
                class="block text-sm font-medium text-gray-700"
              >
                Exhibitor Name
              </label>
              <div class="mt-2">
                <input
                  id="profile_title"
                  v-model="settings_profile_title"
                  type="text"
                  name="profile_title"
                  autocomplete="School Name"
                  :class="inputClass"
                  class="w-full lg:w-1/2"
                />
              </div>
            </div>
            <!-- /Exhibitor name -->

            <!-- Sub title -->
            <div class="py-4">
              <label
                for="profile_sub_title"
                class="block text-sm font-medium text-gray-700"
              >
                Subtitle
              </label>
              <div class="mt-2">
                <input
                  id="profile_sub_title"
                  v-model="settings_profile_sub_title"
                  type="text"
                  name="profile_sub_title"
                  autocomplete="Subtitle"
                  :class="inputClass"
                  class="w-full"
                />
              </div>
            </div>
            <!-- /sub title -->
          </div>
          <div class="flex border-b border-bluegray-300 py-8 w-full">
            <!-- logo -->
            <div class="py-4 w-full lg:w-1/2 relative mr-0 lg:mr-2">
              <label
                for="settingsLogo"
                class="block text-sm font-medium text-gray-700"
                >Logo</label
              >
              <div class="mt-1 flex items-center">
                <div
                  class="banner-changer w-full h-32 my-2 rounded bg-no-repeat bg-center bg-cover flex items-center justify-center shadow-sm relative z-20"
                  :style="{ backgroundImage: `url(${previewImageLogo})` }"
                >
                  <button
                    v-if="!previewLogoChanged"
                    :class="[thinking ? 'opacity-25 cursor-not-allowed' : '']"
                    :disabled="thinking"
                    type="button"
                    class="z-30 absolute right-1/2 bottom-1/2 transform translate-y-1/2 translate-x-1/2 btn btn-trans-white text-white m-0 ml-6"
                    @click="selectImageLogo"
                  >
                    Change
                  </button>
                  <button
                    v-else
                    :class="[thinking ? 'opacity-25 cursor-not-allowed' : '']"
                    :disabled="thinking"
                    type="button"
                    class="z-30 absolute right-1/2 bottom-1/2 transform translate-y-1/2 translate-x-1/2 btn btn-trans-white text-white m-0 ml-6"
                    @click="resetImageLogo"
                  >
                    Cancel
                  </button>
                  <span class="hidden">{{ settings.profile_title }}</span
                  ><!-- Required ... spoof the dom -->
                </div>
                <form ref="settingsLogoForm">
                  <input
                    ref="settingsLogo"
                    type="file"
                    class="hidden"
                    @input="pickImageLogo"
                  />
                </form>
              </div>
              <div class="text-xs text-bluegray-500 mb-4">
                .jpg or .png format with a maximum file size of 1mb
              </div>
              <div v-if="previewImageLogo" class="relative flex items-start">
                <div class="flex items-center h-5">
                  <input
                    id="settings_logo_remove"
                    v-model="settings_logo_remove"
                    name="settings_logo_remove"
                    type="checkbox"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 rounded"
                  />
                </div>
                <div class="ml-3 text-sm">
                  <label
                    for="settings_logo_remove"
                    class="font-medium text-gray-700"
                    >Reset to default</label
                  >
                </div>
              </div>
            </div>
            <!-- /logo -->

            <!-- home banner -->
            <div class="py-4 w-full lg:w-1/2 relative mr-0 lg:mr-2">
              <label
                for="settingsBannerHero"
                class="block text-sm font-medium text-gray-700"
                >Home Page Banner</label
              >
              <div class="mt-1 flex items-center">
                <div
                  class="banner-changer w-full h-32 my-2 rounded bg-no-repeat bg-center bg-cover flex items-center justify-center shadow-sm relative z-20"
                  :style="{ backgroundImage: `url(${previewImageBannerHero})` }"
                >
                  <button
                    v-if="!previewBannerHeroChanged"
                    :class="[thinking ? 'opacity-25 cursor-not-allowed' : '']"
                    :disabled="thinking"
                    type="button"
                    class="z-30 absolute right-1/2 bottom-1/2 transform translate-y-1/2 translate-x-1/2 btn btn-trans-white text-white m-0 ml-6"
                    @click="selectImageHero"
                  >
                    Change
                  </button>
                  <button
                    v-else
                    :class="[thinking ? 'opacity-25 cursor-not-allowed' : '']"
                    :disabled="thinking"
                    type="button"
                    class="z-30 absolute right-1/2 bottom-1/2 transform translate-y-1/2 translate-x-1/2 btn btn-trans-white text-white m-0 ml-6"
                    @click="resetImageHero"
                  >
                    Cancel
                  </button>
                  <span class="hidden">{{ settings.profile_title }}</span
                  ><!-- Required ... spoof the dom -->
                </div>
                <form ref="settingsBannerHeroForm">
                  <input
                    ref="settingsBannerHero"
                    type="file"
                    class="hidden"
                    @input="pickImageHero"
                  />
                </form>
              </div>
              <div class="text-xs text-bluegray-500 mb-4">
                .jpg or .png format with a maximum file size of 1mb
              </div>
              <div
                v-if="previewImageBannerHero"
                class="relative flex items-start"
              >
                <div class="flex items-center h-5">
                  <input
                    id="settings_banner_hero_remove"
                    v-model="settings_banner_hero_remove"
                    name="settings_banner_hero_remove"
                    type="checkbox"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 rounded"
                  />
                </div>
                <div class="ml-3 text-sm">
                  <label
                    for="settings_banner_hero_remove"
                    class="font-medium text-gray-700"
                    >Reset to default</label
                  >
                </div>
              </div>
            </div>
            <!-- /home banner -->
          </div>

          <!-- profile_description -->
          <div class="pb-4 pt-8">
            <label
              for="profile_description"
              class="block text-sm font-medium text-gray-700"
            >
              About Us (Optional)
            </label>
            <div class="mt-2">
              <p
                v-if="badbrowser"
                class="text-red-500 text-xs my-1 w-full flex justify-start items-center space-x-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span
                  >We recommend using Chrome to best utilise all features in
                  this editor.</span
                >
              </p>

              <Editor
                id="profile_description"
                :key="settings_profile_description_original"
                name="profile_description"
                :initial-content="settings_profile_description_original"
                :active-features="[
                  'headings',
                  'bold',
                  'italic',
                  'strike',
                  'highlight',
                  'text_colour',
                  'underline',
                  'h1',
                  'h2',
                  'h3',
                  'alignments',
                  'alignLeft',
                  'alignCenter',
                  'alignRight',
                  'lists',
                  'bulletList',
                  'orderedList',
                  'blockquote',
                  'code',
                  'codeBlock',
                  'link',
                  'remove_link',
                  'image',
                  'tables',
                  'table',
                  'horizontalRule',
                  'undo',
                  'redo',
                ]"
                @update-content="updateEditorContent"
              />

              <div class="text-xs text-bluegray-500 mt-2 mb-4">
                Text in this field will appear as a 'read more' button on your
                home page.
              </div>
            </div>
          </div>
          <!-- /profile_description -->
        </div>
      </div>

      <!-- CONTENT Col 2 -->
      <div
        class="bg-white rounded-xl shadow w-full lg:w-1/2 p-6 pt-16 lg:-mt-48 2xl:py-12 2xl:px-12"
      >
        <div class="w-full border-b border-bluegray-300 pb-16">
          <h2>Contact Details</h2>

          <!-- contact -->
          <div class="py-4">
            <label
              for="enabled_contact"
              class="block w-full text-sm font-medium text-gray-700"
              >Contact Form</label
            >

            <div class="my-2 flex items-center justify-start space-x-2">
              <input
                v-if="!disable"
                id="contact_email"
                v-model="settings_contact_email"
                type="email"
                name="contact_email"
                autocomplete="contact email"
                :class="inputClass"
                class="w-full"
              />
              <input
                v-else
                id="disabled_contact_email"
                disabled
                :placeholder="settings_contact_email_original"
                type="text"
                :class="[inputClass, 'bg-gray-200']"
                class="w-full"
              />

              <div
                v-if="settings_contact_email_original"
                class="w-24 cursor-pointer text-sm text text-expo_red"
              >
                <p
                  v-if="settings_contact_email"
                  @click="
                    ;(disable = !disable),
                      (settings_contact_email = settings_contact_email
                        ? null
                        : settings_contact_email_original)
                  "
                >
                  Disable
                </p>
                <p
                  v-else
                  @click="
                    ;(disable = !disable),
                      (settings_contact_email = settings_contact_email
                        ? null
                        : settings_contact_email_original)
                  "
                >
                  Reset
                </p>
              </div>
            </div>

            <div class="text-xs text-bluegray-500">
              Enable your contact form by inserting a valid contact email
              address.
            </div>
          </div>
          <!-- /contact -->

          <!-- ADDRESS INPUTS : HIDDEN UNTIL REQUIRED! -->
          <div class="py-4 hidden">
            <label
              for="address_line1"
              class="block text-sm font-medium text-gray-700"
            >
              Address Line 1
            </label>
            <div class="mt-2 hidden">
              <input
                id="address_line1"
                v-model="settings_address_line1"
                type="text"
                name="address_line1"
                autocomplete="Address line 1"
                :class="inputClass"
                class="w-full"
              />
            </div>
          </div>

          <div class="py-4 hidden">
            <label
              for="address_line2"
              class="block text-sm font-medium text-gray-700"
            >
              Address Line 2
            </label>
            <div class="mt-2">
              <input
                id="address_line2"
                v-model="settings_address_line2"
                type="text"
                name="address_line2"
                autocomplete="Address line 2"
                :class="inputClass"
                class="w-full"
              />
            </div>
          </div>

          <div class="py-4 hidden">
            <label
              for="address_line3"
              class="block text-sm font-medium text-gray-700"
            >
              Address Line 3
            </label>
            <div class="mt-2">
              <input
                id="address_line3"
                v-model="settings_address_line3"
                type="text"
                name="address_line3"
                autocomplete="Address line 3"
                :class="inputClass"
                class="w-full"
              />
            </div>
          </div>
          <!-- ADDRESS INPUTS : HIDDEN UNTIL REQUIRED! -->

          <!-- Contact Phone -->
          <div class="py-4">
            <label
              for="contact_telephone"
              class="block text-sm font-medium text-gray-700"
            >
              Contact Phone Number
            </label>
            <div class="mt-2">
              <input
                id="contact_telephone"
                v-model="settings_contact_telephone"
                type="tel"
                name="contact_telephone"
                autocomplete="contact phone"
                :class="inputClass"
                class="w-full"
              />
            </div>
          </div>

          <!-- Website -->
          <div class="py-4">
            <label
              for="website"
              class="block text-sm font-medium text-gray-700"
            >
              Website
            </label>
            <div class="mt-2">
              <input
                id="website"
                v-model="settings_website"
                type="text"
                name="website"
                autocomplete="website"
                :class="inputClass"
                class="w-full"
              />
              <p v-if="!valid_website_url" class="text-xs text-red-500">
                Please provide a valid URL
              </p>
            </div>
          </div>
        </div>

        <!-- Socials -->
        <div class="py-16">
          <div class="flex items-end mb-2">
            <h2 class="m-0">Socials</h2>
            <p class="ml-4">Optional</p>
          </div>
          <div class="flex">
            <div class="relative pt-2">
              <svg
                v-if="settings_social_fb && settings_social_fb.length > 0"
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 text-expo_red absolute top-0 right-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <svg
                :class="
                  social_open === 'fb' ? 'text-expo_red' : 'text-expo_dblue'
                "
                fill="currentColor"
                class="cursor-pointer hover:text-expo_red h-5 w-5 mr-5"
                role="img"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                @click="handleSocials('fb')"
              >
                <title>Facebook</title>
                <path
                  d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                />
              </svg>
            </div>
            <div class="relative pt-2">
              <svg
                v-if="
                  settings_social_linked && settings_social_linked.length > 0
                "
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 text-expo_red absolute top-0 right-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <svg
                :class="
                  social_open === 'linked' ? 'text-expo_red' : 'text-expo_dblue'
                "
                fill="currentColor"
                class="cursor-pointer hover:text-expo_red h-5 w-5 mr-5"
                role="img"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                @click="handleSocials('linked')"
              >
                <title>LinkedIn</title>
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                />
              </svg>
            </div>
            <div class="relative pt-2">
              <svg
                v-if="settings_social_insta && settings_social_insta.length > 0"
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 text-expo_red absolute top-0 right-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <svg
                :class="
                  social_open === 'insta' ? 'text-expo_red' : 'text-expo_dblue'
                "
                fill="currentColor"
                class="cursor-pointer hover:text-expo_red h-5 w-5 mr-5"
                role="img"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                @click="handleSocials('insta')"
              >
                <title>Instagram</title>
                <path
                  d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"
                />
              </svg>
            </div>
            <div class="relative pt-2">
              <svg
                v-if="settings_social_yt && settings_social_yt.length"
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 text-expo_red absolute top-0 right-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <svg
                :class="
                  social_open === 'yt' ? 'text-expo_red' : 'text-expo_dblue'
                "
                fill="currentColor"
                class="cursor-pointer hover:text-expo_red h-5 w-5 mr-5"
                role="img"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                @click="handleSocials('yt')"
              >
                <title>YouTube</title>
                <path
                  d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                />
              </svg>
            </div>
            <div class="relative pt-2">
              <svg
                v-if="settings_social_twit && settings_social_twit.length"
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 text-expo_red absolute top-0 right-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <svg
                :class="
                  social_open === 'twit' ? 'text-expo_red' : 'text-expo_dblue'
                "
                fill="currentColor"
                class="cursor-pointer hover:text-expo_red h-5 w-5 mr-5"
                role="img"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                @click="handleSocials('twit')"
              >
                <title>Twitter</title>
                <path
                  d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"
                />
              </svg>
            </div>
          </div>

          <div
            class="relative overflow-hidden mt-4"
            :class="[
              !valid_settings_social_fb ||
              !valid_settings_social_yt ||
              !valid_settings_social_insta ||
              !valid_settings_social_linked ||
              !valid_settings_social_twit
                ? 'h-28'
                : 'h-24',
            ]"
          >
            <!-- fb -->
            <div
              class="w-full py-4 absolute top-0 left-0 transition-all duration-700 ease-in-out transform"
              :class="[
                social_open === 'fb'
                  ? 'opacity-100 translate-y-0'
                  : '-translate-y-full opacity-0 pointer-events-none',
              ]"
            >
              <label
                for="social_fb"
                class="block text-sm font-medium text-gray-700"
              >
                Facebook URL
              </label>
              <div class="mt-2 flex space-x-4 items-center">
                <!-- <p class="text-sm text-bluegray-400">https://</p> -->
                <input
                  id="social_fb"
                  v-model="settings_social_fb"
                  type="text"
                  name="social_fb"
                  autocomplete="social_fb"
                  :class="inputClass"
                  class="w-full"
                />
              </div>
              <p v-if="!valid_settings_social_fb" class="text-xs text-red-500">
                Please provide a valid URL
              </p>
            </div>

            <!-- yt -->
            <div
              class="w-full py-4 absolute top-0 left-0 transition-all duration-700 ease-in-out transform"
              :class="[
                social_open === 'yt'
                  ? 'opacity-100 translate-y-0'
                  : '-translate-y-full opacity-0 pointer-events-none',
              ]"
            >
              <label
                for="social_yt"
                class="block text-sm font-medium text-gray-700"
              >
                Youtube URL
              </label>
              <div class="mt-2 flex space-x-4 items-center">
                <!-- <p class="text-sm text-bluegray-400">https://</p> -->
                <input
                  id="social_yt"
                  v-model="settings_social_yt"
                  type="text"
                  name="social_yt"
                  autocomplete="social_yt"
                  :class="inputClass"
                  class="w-full"
                />
              </div>
              <p v-if="!valid_settings_social_yt" class="text-xs text-red-500">
                Please provide a valid URL
              </p>
            </div>

            <!-- insta -->
            <div
              class="w-full py-4 absolute top-0 left-0 transition-all duration-700 ease-in-out transform"
              :class="[
                social_open === 'insta'
                  ? 'opacity-100 translate-y-0'
                  : '-translate-y-full opacity-0 pointer-events-none',
              ]"
            >
              <label
                for="social_insta"
                class="block text-sm font-medium text-gray-700"
              >
                Instagram URL
              </label>
              <div class="mt-2 flex space-x-4 items-center">
                <!-- <p class="text-sm text-bluegray-400">https://</p> -->
                <input
                  id="social_insta"
                  v-model="settings_social_insta"
                  type="text"
                  name="social_insta"
                  autocomplete="social_insta"
                  :class="inputClass"
                  class="w-full"
                />
              </div>
              <p
                v-if="!valid_settings_social_insta"
                class="text-xs text-red-500"
              >
                Please provide a valid URL
              </p>
            </div>

            <!-- linked -->
            <div
              class="w-full py-4 absolute top-0 left-0 transition-all duration-700 ease-in-out transform"
              :class="[
                social_open === 'linked'
                  ? 'opacity-100 translate-y-0'
                  : '-translate-y-full opacity-0 pointer-events-none',
              ]"
            >
              <label
                for="social_linked"
                class="block text-sm font-medium text-gray-700"
              >
                LinkedIn URL
              </label>
              <div class="mt-2 flex space-x-4 items-center">
                <!-- <p class="text-sm text-bluegray-400">https://</p> -->
                <input
                  id="social_linked"
                  v-model="settings_social_linked"
                  type="text"
                  name="social_linked"
                  autocomplete="social_linked"
                  :class="inputClass"
                  class="w-full"
                />
              </div>
              <p
                v-if="!valid_settings_social_linked"
                class="text-xs text-red-500"
              >
                Please provide a valid URL
              </p>
            </div>

            <!-- twitter -->
            <div
              class="w-full py-4 absolute top-0 left-0 transition-all duration-700 ease-in-out transform"
              :class="[
                social_open === 'twit'
                  ? 'opacity-100 translate-y-0'
                  : '-translate-y-full opacity-0 pointer-events-none',
              ]"
            >
              <label
                for="social_twit"
                class="block text-sm font-medium text-gray-700"
              >
                Twitter URL
              </label>
              <div class="mt-2 flex space-x-4 items-center">
                <!-- <p class="text-sm text-bluegray-400">https://</p> -->
                <input
                  id="social_twit"
                  v-model="settings_social_twit"
                  type="text"
                  name="social_twit"
                  autocomplete="social_twit"
                  :class="inputClass"
                  class="w-full"
                />
              </div>
              <p
                v-if="!valid_settings_social_twit"
                class="text-xs text-red-500"
              >
                Please provide a valid URL
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '../../../js/plugins/event-bus.js'
import { shared } from '../../../js/mixins/shared.js'
import { Twitter } from 'vue-color'
import Editor from '../../../careerwise/tenant/manager/components/editor-wysiwyg/Editor.vue'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default {
  components: {
    'twitter-picker': Twitter,
    Editor,
  },

  mixins: [shared],

  data() {
    return {
      badbrowser: false,

      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      thinking: false,

      canSubmit: false,

      // Site title
      settings_profile_title: null,
      settings_profile_title_original: null,

      // Site subtitle
      settings_profile_sub_title: null,
      settings_profile_sub_title_original: null,

      // Optional home page read more bio
      settings_profile_description: null,
      settings_profile_description_original: null,

      // Logo
      settings_logo: null,
      settings_logo_original: null,
      previewImageLogo: null,
      previewLogoChanged: false,
      settings_logo_remove: false,

      // Home page banner
      settings_banner_hero: null,
      settings_banner_hero_original: null,
      previewImageBannerHero: null,
      previewBannerHeroChanged: false,
      settings_banner_hero_remove: false,

      // Contact form enabled
      settings_enabled_contact: false,
      settings_enabled_contact_original: false,

      // Address lines
      settings_address_line1: null,
      settings_address_line1_original: null,

      settings_address_line2: null,
      settings_address_line2_original: null,

      settings_address_line3: null,
      settings_address_line3_original: null,

      // Contact info
      disable: false,
      settings_contact_email: null,
      settings_contact_email_original: null,

      settings_contact_telephone: null,
      settings_contact_telephone_original: null,

      settings_website: null,
      settings_website_original: null,

      // Socials
      settings_social_yt: false,
      settings_social_yt_original: false,
      valid_settings_social_yt: true,

      settings_social_linked: false,
      settings_social_linked_original: false,
      valid_settings_social_linked: true,

      settings_social_fb: false,
      settings_social_fb_original: false,
      valid_settings_social_fb: true,

      settings_social_twit: false,
      settings_social_twit_original: false,
      valid_settings_social_twit: true,

      settings_social_insta: false,
      settings_social_insta_original: false,
      valid_settings_social_insta: true,

      update: {
        profile_title: null,
        profile_sub_title: null,
        profile_description: null,
        logo: null,
        logo_remove: null,
        banner_hero: null,
        banner_hero_remove: null,
        enabled_contact: null,
        address_line1: null,
        address_line2: null,
        address_line3: null,
        contact_email: null,
        contact_telephone: null,
        website: null,
        social_fb: null,
        social_linked: null,
        social_insta: null,
        social_yt: null,
        social_twit: null,
      },

      social_open: false,

      inputClass:
        'flex justify-center items-center sm:text-sm text-bluegray-700 focus:text-black active:text-black focus:outline-none active:outline-none transition-all duration-100 ease-in-out border border-bluegray-300 focus:border-black active:border-black rounded bg-white px-4 h-12',
      alert: false, // { status : '', message : ''}

      valid_website_url: true,
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
    }),
  },

  watch: {
    settings_profile_title: {
      handler: function (val) {
        if (this.settings_profile_title_original !== val) {
          if (val.length < 1 && this.settings_profile_title_original === null) {
            val = null
          }
          this.compileUpdate('profile_title', val)
        } else {
          this.compileUpdate('profile_title', null)
        }
      },

      deep: true,
    },

    settings_profile_sub_title: {
      handler: function (val) {
        if (this.settings_profile_sub_title_original !== val) {
          if (
            val.length < 1 &&
            this.settings_profile_sub_title_original === null
          ) {
            val = null
          }
          this.compileUpdate('profile_sub_title', val)
        } else {
          this.compileUpdate('profile_sub_title', null)
        }
      },

      deep: true,
    },

    settings_profile_description: {
      handler: function (val) {
        if (this.settings_profile_description_original !== val) {
          if (
            val.length < 1 &&
            this.settings_profile_description_original === null
          ) {
            val = null
          }
          this.compileUpdate('profile_description', val)
        } else {
          this.compileUpdate('profile_description', null)
        }
      },

      deep: true,
    },

    settings_logo: {
      handler: function (val) {
        if (this.settings_logo_original !== val) {
          this.compileUpdate('logo', val)
        } else {
          this.compileUpdate('logo', null)
        }
      },

      deep: true,
    },

    settings_logo_remove: {
      handler: function (val) {
        if (val) {
          this.$set(this, 'previewLogoChanged', false)
          this.$set(this, 'previewImageLogo', this.settings_logo_original)
        }

        if (val) {
          this.compileUpdate('logo_remove', true)
        } else {
          this.compileUpdate('logo_remove', null)
        }
      },

      deep: true,
    },

    settings_banner_hero: {
      handler: function (val) {
        if (this.settings_banner_hero_original !== val) {
          this.compileUpdate('banner_hero', val)
        } else {
          this.compileUpdate('banner_hero', null)
        }
      },

      deep: true,
    },

    settings_banner_hero_remove: {
      handler: function (val) {
        if (val) {
          this.$set(this, 'previewBannerHeroChanged', false)
          this.$set(
            this,
            'previewImageBannerHero',
            this.settings_banner_hero_original,
          )
        }

        if (val) {
          this.compileUpdate('banner_hero_remove', true)
        } else {
          this.compileUpdate('banner_hero_remove', null)
        }
      },

      deep: true,
    },

    settings_address_line1: {
      handler: function (val) {
        if (this.settings_address_line1_original !== val) {
          if (val.length < 1 && this.settings_address_line1_original === null) {
            val = null
          }

          this.compileUpdate('address_line1', val)
        } else {
          this.compileUpdate('address_line1', null)
        }
      },

      deep: true,
    },

    settings_address_line2: {
      handler: function (val) {
        if (this.settings_address_line2_original !== val) {
          if (val.length < 1 && this.settings_address_line2_original === null) {
            val = null
          }
          this.compileUpdate('address_line2', val)
        } else {
          this.compileUpdate('address_line2', null)
        }
      },

      deep: true,
    },

    settings_address_line3: {
      handler: function (val) {
        if (this.settings_address_line3_original !== val) {
          if (val.length < 1 && this.settings_address_line3_original === null) {
            val = null
          }
          this.compileUpdate('address_line3', val)
        } else {
          this.compileUpdate('address_line3', null)
        }
      },

      deep: true,
    },

    disable: {
      handler: function (val) {
        if (val) {
          this.compileUpdate('email_disabled', true)
        } else {
          this.compileUpdate('email_disabled', null)
        }
      },

      deep: true,
    },

    settings_contact_email: {
      handler: function (val) {
        if (this.settings_contact_email_original !== val) {
          // validate this email first! ====
          let valid = this.validateEmail(val)
          if (!valid) {
            val = null
          }
          this.compileUpdate('contact_email', val)
        } else {
          this.compileUpdate('contact_email', null)
        }
      },

      deep: true,
    },

    settings_contact_telephone: {
      handler: function (val) {
        if (this.settings_contact_telephone_original !== val) {
          if (
            val.length < 1 &&
            this.settings_contact_telephone_original === null
          ) {
            val = null
          }
          this.compileUpdate('contact_telephone', val)
        } else {
          this.compileUpdate('contact_telephone', null)
        }
      },

      deep: true,
    },

    settings_website: {
      handler: function (url) {
        if (url) {
          if (url.length > 0) {
            if (!this.validateURL(url)) {
              this.$set(this, 'valid_website_url', false)
            } else {
              if (!this.validateURLProtocol(url)) {
                url = this.updateURLWithProtocol(url)
              }
              this.$set(this, 'valid_website_url', true)
            }
          } else {
            this.$set(this, 'valid_website_url', true)
          }
        } else {
          this.$set(this, 'valid_website_url', true)
        }

        if (this.settings_website_original !== url) {
          if (url.length < 1 && this.settings_website_original === null) {
            url = null
          }
          this.compileUpdate('website', url)
        } else {
          this.compileUpdate('website', null)
        }
      },

      deep: true,
    },

    settings_social_yt: {
      handler: function (val) {
        if (!val) {
          this.$set(this, 'valid_settings_social_yt', true)
          this.compileUpdate('social_yt', '')
          this.$set(this, 'settings_social_yt', '')
          return
        }

        if (val.length > 0) {
          if (!this.validateURL(val)) {
            this.$set(this, 'valid_settings_social_yt', false)
          } else {
            if (!this.validateURLProtocol(val)) {
              val = this.$set(
                this,
                'settings_social_yt',
                this.updateURLWithProtocol(val),
              )
            }
            this.$set(this, 'valid_settings_social_yt', true)
          }
        } else {
          this.$set(this, 'valid_settings_social_yt', true)
        }

        if (this.settings_social_yt_original !== val) {
          if (val.length < 1 && this.settings_social_yt_original === null) {
            val = null
          }
          this.compileUpdate('social_yt', val)
        } else {
          this.compileUpdate('social_yt', null)
        }
      },

      deep: true,
    },

    settings_social_linked: {
      handler: function (val) {
        if (!val) {
          this.$set(this, 'valid_settings_social_linked', true)
          this.compileUpdate('social_linked', '')
          this.$set(this, 'settings_social_linked', '')
          return
        }

        if (val.length > 0) {
          if (!this.validateURL(val)) {
            this.$set(this, 'valid_settings_social_linked', false)
          } else {
            if (!this.validateURLProtocol(val)) {
              val = this.$set(
                this,
                'settings_social_linked',
                this.updateURLWithProtocol(val),
              )
            }
            this.$set(this, 'valid_settings_social_linked', true)
          }
        } else {
          this.$set(this, 'valid_settings_social_linked', true)
        }

        if (this.settings_social_linked_original !== val) {
          if (val.length < 1 && this.settings_social_linked_original === null) {
            val = null
          }
          this.compileUpdate('social_linked', val)
        } else {
          this.compileUpdate('social_linked', null)
        }
      },

      deep: true,
    },

    settings_social_insta: {
      handler: function (val) {
        if (!val) {
          this.$set(this, 'valid_settings_social_insta', true)
          this.compileUpdate('social_insta', '')
          this.$set(this, 'settings_social_insta', '')
          return
        }

        if (val.length > 0) {
          if (!this.validateURL(val)) {
            this.$set(this, 'valid_settings_social_insta', false)
          } else {
            if (!this.validateURLProtocol(val)) {
              val = this.$set(
                this,
                'settings_social_insta',
                this.updateURLWithProtocol(val),
              )
            }
            this.$set(this, 'valid_settings_social_insta', true)
          }
        } else {
          this.$set(this, 'valid_settings_social_insta', true)
        }

        if (this.settings_social_insta_original !== val) {
          if (val.length < 1 && this.settings_social_insta_original === null) {
            val = null
          }
          this.compileUpdate('social_insta', val)
        } else {
          this.compileUpdate('social_insta', null)
        }
      },

      deep: true,
    },

    settings_social_fb: {
      handler: function (val) {
        if (!val) {
          this.$set(this, 'valid_settings_social_fb', true)
          this.compileUpdate('social_fb', '')
          this.$set(this, 'settings_social_fb', '')
          return
        }

        if (val.length > 0) {
          if (!this.validateURL(val)) {
            this.$set(this, 'valid_settings_social_fb', false)
          } else {
            if (!this.validateURLProtocol(val)) {
              val = this.$set(
                this,
                'settings_social_fb',
                this.updateURLWithProtocol(val),
              )
            }
            this.$set(this, 'valid_settings_social_fb', true)
          }
        } else {
          this.$set(this, 'valid_settings_social_fb', true)
        }

        if (this.settings_social_fb_original !== val) {
          if (val.length < 1 && this.settings_social_fb_original === null) {
            val = null
          }
          this.compileUpdate('social_fb', val)
        } else {
          this.compileUpdate('social_fb', null)
        }
      },

      deep: true,
    },

    settings_social_twit: {
      handler: function (val) {
        if (!val) {
          this.$set(this, 'valid_settings_social_twit', true)
          this.compileUpdate('social_twit', '')
          this.$set(this, 'settings_social_twit', '')
          return
        }

        if (val.length > 0) {
          if (!this.validateURL(val)) {
            this.$set(this, 'valid_settings_social_twit', false)
          } else {
            if (!this.validateURLProtocol(val)) {
              val = this.$set(
                this,
                'settings_social_twit',
                this.updateURLWithProtocol(val),
              )
            }
            this.$set(this, 'valid_settings_social_twit', true)
          }
        } else {
          this.$set(this, 'valid_settings_social_twit', true)
        }

        if (this.settings_social_twit_original !== val) {
          if (val.length < 1 && this.settings_social_twit_original === null) {
            val = null
          }
          this.compileUpdate('social_twit', val)
        } else {
          this.compileUpdate('social_twit', null)
        }
      },

      deep: true,
    },
  },

  mounted() {
    this.setSettings()

    // Determine if we need to show a browser warning...
    let badbrowser = document.getElementsByTagName('body')[0].dataset.badbrowser
    if (badbrowser) {
      this.$set(this, 'badbrowser', true)
    }

    EventBus.$on('websiteSettingsUpdated', () => {
      this.$set(this, 'canSubmit', false)
      this.setSettings()
    })
  },

  methods: {
    setSettings() {
      // site title
      this.$set(this, 'settings_profile_title', this.settings.profile_title)
      this.$set(
        this,
        'settings_profile_title_original',
        this.settings.profile_title,
      )

      // site subtitle
      this.$set(
        this,
        'settings_profile_sub_title',
        this.settings.profile_sub_title,
      )
      this.$set(
        this,
        'settings_profile_sub_title_original',
        this.settings.profile_sub_title,
      )

      // optional home page read more bio
      this.$set(
        this,
        'settings_profile_description',
        this.settings.profile_description,
      )
      this.$set(
        this,
        'settings_profile_description_original',
        this.settings.profile_description,
      )

      // logo
      this.$set(this, 'settings_logo', this.settings.logo)
      this.$set(this, 'settings_logo_original', this.settings.logo)
      this.$set(this, 'previewImageLogo', this.settings.logo)
      this.$set(this, 'previewLogoChanged', false)
      this.$set(this, 'settings_logo_remove', false)

      // home page banner
      this.$set(this, 'settings_banner_hero', this.settings.banner_hero)
      this.$set(
        this,
        'settings_banner_hero_original',
        this.settings.banner_hero,
      )
      this.$set(this, 'previewImageBannerHero', this.settings.banner_hero)
      this.$set(this, 'previewBannerHeroChanged', false)
      this.$set(this, 'settings_banner_hero_remove', false)

      // contact form enabled
      this.$set(this, 'settings_enabled_contact', this.settings.enabled_contact)
      this.$set(
        this,
        'settings_enabled_contact_original',
        this.settings.enabled_contact,
      )

      // address lines
      this.$set(this, 'settings_address_line1', this.settings.address_line1)
      this.$set(
        this,
        'settings_address_line1_original',
        this.settings.address_line1,
      )

      this.$set(this, 'settings_address_line2', this.settings.address_line2)
      this.$set(
        this,
        'settings_address_line2_original',
        this.settings.address_line2,
      )

      this.$set(this, 'settings_address_line3', this.settings.address_line3)
      this.$set(
        this,
        'settings_address_line3_original',
        this.settings.address_line3,
      )

      // contact info
      this.$set(this, 'settings_contact_email', this.settings.contact_email)
      this.$set(
        this,
        'settings_contact_email_original',
        this.settings.contact_email,
      )

      this.$set(
        this,
        'settings_contact_telephone',
        this.settings.contact_telephone,
      )
      this.$set(
        this,
        'settings_contact_telephone_original',
        this.settings.contact_telephone,
      )

      this.$set(this, 'settings_website', this.settings.website)
      this.$set(this, 'settings_website_original', this.settings.website)

      // socials
      this.$set(this, 'settings_social_yt', this.settings.social_yt)
      this.$set(this, 'settings_social_yt_original', this.settings.social_yt)
      this.$set(this, 'valid_settings_social_yt', this.settings.social_yt)

      this.$set(this, 'settings_social_linked', this.settings.social_linked)
      this.$set(
        this,
        'settings_social_linked_original',
        this.settings.social_linked,
      )
      this.$set(
        this,
        'valid_settings_social_linked',
        this.settings.social_linked,
      )

      this.$set(this, 'settings_social_fb', this.settings.social_fb)
      this.$set(this, 'settings_social_fb_original', this.settings.social_fb)
      this.$set(this, 'valid_settings_social_fb', this.settings.social_fb)

      this.$set(this, 'settings_social_twit', this.settings.social_twit)
      this.$set(
        this,
        'settings_social_twit_original',
        this.settings.social_twit,
      )
      this.$set(this, 'valid_settings_social_twit', this.settings.social_twit)

      this.$set(this, 'settings_social_insta', this.settings.social_insta)
      this.$set(
        this,
        'settings_social_insta_original',
        this.settings.social_insta,
      )
      this.$set(this, 'valid_settings_social_insta', this.settings.social_insta)
    },

    updateEditorContent(val) {
      this.$set(this, 'settings_profile_description', val)
    },

    // IMAGE METHODS:
    selectImageLogo() {
      this.$refs.settingsLogo.click()
    },

    pickImageLogo() {
      let file = this.$refs.settingsLogo.files
      if (file && file[0]) {
        if (!this.validateImageFormat(file[0])) {
          return
        }
      }

      let reader = new FileReader()
      this.$set(this, 'settings_logo', file[0])
      reader.onload = (e) => {
        this.$set(this, 'previewLogoChanged', true)
        this.$set(this, 'settings_logo_remove', false)
        this.previewImageLogo = e.target.result
      }
      reader.readAsDataURL(file[0])
      this.$emit('input', file[0])
    },

    resetImageLogo() {
      this.$set(this, 'previewLogoChanged', false)
      this.$set(this, 'settings_logo', null)
      this.$set(this, 'previewImageLogo', this.settings_logo_original)
      this.$refs.settingsLogoForm.reset()
    },

    // HERO BANNER
    selectImageHero() {
      this.$refs.settingsBannerHero.click()
    },

    pickImageHero() {
      let file = this.$refs.settingsBannerHero.files
      if (file && file[0]) {
        if (!this.validateImageFormat(file[0])) {
          return
        }
      }

      let reader = new FileReader()
      this.$set(this, 'settings_banner_hero', file[0])
      reader.onload = (e) => {
        this.$set(this, 'previewBannerHeroChanged', true)
        this.$set(this, 'settings_banner_hero_remove', false)
        this.previewImageBannerHero = e.target.result
      }

      reader.readAsDataURL(file[0])
      this.$emit('input', file[0])
    },

    resetImageHero() {
      this.$set(this, 'previewBannerHeroChanged', false)
      this.$set(this, 'settings_banner_hero', null)
      this.$set(
        this,
        'previewImageBannerHero',
        this.settings_banner_hero_original,
      )
      this.$refs.settingsBannerHeroForm.reset()
    },

    // SWISS ARMY SUBISSION DATA HELPER

    compileUpdate(node = '', val) {
      this.$set(this.update, node, val)

      let canSubmit = 0
      Object.entries(this.update).map(([, value]) => {
        canSubmit = value !== null ? (canSubmit = canSubmit + 1) : canSubmit
      })

      if (node === 'website' && val) {
        if (this.validateURL(val)) {
          canSubmit = 1
        } else {
          canSubmit = 0
        }
      }
      if (
        node === 'website' &&
        !val &&
        val !== this.settings_website_original
      ) {
        canSubmit = 1 // Do not allow saving a URL that is not well constructed...
      }

      // If the node is
      if (node === 'enabled_contact') {
        let valid = this.contactEnabledValidate()
        if (!valid) {
          canSubmit = 0
        }
      }

      if (canSubmit > 0) {
        this.$set(this, 'canSubmit', true)
      } else {
        this.$set(this, 'canSubmit', false)
      }
    },

    resetUpdateData() {
      Object.entries(this.update).map(([key]) => {
        this.compileUpdate(key, null)
      })
    },

    contactEnabledValidate() {
      let valid = true

      let contact_email = this.validateEmail(this.update.contact_email)
      let contact_email_original = this.validateEmail(
        this.settings_contact_email_original,
      )

      // Check if the input email is valid OR orignal input is valid, in order for email contact for validation to be cleared.
      if (!contact_email && !contact_email_original) {
        valid = false
      }

      return valid
    },

    handleSocials(platform) {
      this.$set(this, 'social_open', platform)
    },

    // SAVE API

    submitUpdates() {
      if (!this.canSubmit) {
        return
      }
      let submitData = new FormData()
      let includesFontsOrColours = []
      Object.entries(this.update).map(([key, value]) => {
        if (value === null || value === undefined) {
          //...
        } else {
          if (
            key === 'primary_colour' ||
            key === 'font_title' ||
            key === 'font_body'
          ) {
            includesFontsOrColours.push(key)
          }
          if (
            (key === 'website' ||
              key === 'contact_telephone' ||
              key === 'profile_sub_title' ||
              key === 'social_fb' ||
              key === 'social_linked' ||
              key === 'social_insta' ||
              key === 'social_yt' ||
              key === 'social_twit' ||
              key === 'profile_description') &&
            value.length < 1
          ) {
            switch (key) {
              case 'website':
                key = 'remove_website'
                value = true
                break

              case 'contact_telephone':
                key = 'remove_contact_telephone'
                value = true
                break

              case 'profile_sub_title':
                key = 'remove_profile_sub_title'
                value = true
                break

              case 'social_fb':
                key = 'remove_social_fb'
                value = true
                break

              case 'social_linked':
                key = 'remove_social_linked'
                value = true
                break

              case 'social_insta':
                key = 'remove_social_insta'
                value = true
                break

              case 'social_yt':
                key = 'remove_social_yt'
                value = true
                break

              case 'social_twit':
                key = 'remove_social_twit'
                value = true
                break

              case 'profile_description':
                key = 'remove_profile_description'
                value = true
                break

              default:
                break
            }
          }
          submitData.append(`${key}`, value)
        }
      })

      this.$set(this, 'thinking', true)

      axios.post('/api/auth/update-settings', submitData).then((response) => {
        if (response.data.success) {
          // Check if we have returned settings that we need to update the store with?!?!?
          if (response.data.settings) {
            EventBus.$emit('reloadWebsiteSettings')
          }

          this.resetUpdateData()
        }

        this.$set(this, 'thinking', false)
        this.$set(this, 'disable', false)

        if (response.data.alert) {
          EventBus.$emit('triggerAlertResponse', response.data.alert)
        }

        if (includesFontsOrColours.length > 0) {
          window.location.reload()
        }
      })
    },
  },
}
</script>

<style scoped>
.banner-changer::after {
  background: #000;
  opacity: 0.6;
  content: '';
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 0.25rem;
}

.vc-twitter {
  box-shadow: none !important;
  border: 1px solid rgb(212, 212, 212);
}
</style>
